module.exports = __webpack_public_path__ + "static/img/logo-small.dcc80de8.png";